<template>
    <div>
        <v-main>
            <v-container fluid>
                <v-card id="titlecard" flat>
                    <v-row cols="12" dense>
                        <v-col cols="12">
                            <h2>{{ this.title }}</h2><h5 class="subtitle-weight">(Nr. of changes in selection: {{ this.filteredChanges.length }})</h5>
                        </v-col>
                    </v-row>
                    <v-row dense cols="12">
                        <v-col cols="2">
                            <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                        </v-col>
                        <v-col cols="2" v-if="params[0] != 'user'" class="pl-4">
                            <select_gebr :selected_gebr="selected_gebr" field="selected_gebr" label="Assigned to" :isDense="false" :isClearable="true" @updateData="updateData"/>                         
                        </v-col>
                        <v-col cols="1" class="pl-4 pt-6">
                            <date_picker label="Arrival from" icon="mdi-calendar" :date="arrivalDateFromISO" field="arrivalDateFromISO" @updateData="updateData"/> 
                        </v-col>                        
                        <v-col cols="1" class="pl-4 pt-6">
                            <date_picker label="Arrival until" icon="mdi-calendar" :date="arrivalDateUntilISO" field="arrivalDateUntilISO" @updateData="updateData"/> 
                        </v-col>  
                        <v-col cols="3" class="pl-4">
                            <filter_eventstatus :selected_stats="selected_hwst" label="Status" field="selected_hwst" :isClearable="true" @updateData="updateData" ref="cbo_eventstatus"/>    
                        </v-col>                                                                      
                        <v-col cols="1" class="pl-8 pt-6">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-spacer/>
                                <v-icon v-bind="attrs" v-on="on" medium color="green" v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
                            </template>
                            <span>Export data to Excel</span>
                        </v-tooltip>
                        </v-col>                                                            
                    </v-row>
                </v-card>
                <v-row class="row-default">
                    <v-col cols="12" class="px-2">
                        <v-data-table id="x" 
                            dense 
                            :headers="getHowzHeaders()" 
                            :items="filteredChanges" 
                            :disable-pagination=true
                            hide-default-footer 
                            item-key="activity" 
                            :loading="loading"
                            loading-text="Loading data...please wait" 
                            fixed-header 
                            :search="search"
                            :height="wInnerHeight">   
                            <template v-slot:header.attachments>
                                <v-icon small>mdi-paperclip</v-icon>
                            </template>          
                            <template v-slot:header.sort>
                                <v-icon small>mdi-flag-variant-outline</v-icon>
                            </template>                
                            <template v-slot:item="change">
                                <tr>
                                    <td class="td_markup">
                                        <table>
                                            <tr>
                                                <td class="row-pointer booking-color td_markup_inner">
                                                    <span v-on:click="$router.open('/huov/onHuov/' + change.item.huov_encrid)">{{ change.item.booking }}</span>
                                                </td>
                                            </tr>
                                            <tr v-if="change.item.partner!==''">
                                                <td>
                                                    {{change.item.partner}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span class="td_markup_xs">{{change.item.arrival_dmy}}</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="td_markup"><div v-if="change.item.cttp_nr==='5'"><v-icon color="error" size="20">mdi-alpha-e-circle</v-icon></div></td>
                                    <td class="td_markup">{{ change.item.guest }}</td>
                                    <td class="td_markup">
                                        {{ $moment(change.item.created).format("DD-MM-YYYY HH:mm") }}
                                    </td>
                                    <!-- <td class="td_markup">
                                        <div v-if="change.item.flag!==''">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-if="change.item.flag==='red'">
                                                        <v-icon v-bind="attrs" v-on="on" small color="red">mdi-flag-variant</v-icon>
                                                    </span> 
                                                    <span v-else>
                                                        <v-icon v-bind="attrs" v-on="on" small color="orange">mdi-flag-variant</v-icon>
                                                    </span>
                                                </template>
                                                <span>{{ change.item.flag_expl }}</span>
                                            </v-tooltip>                                          
                                        </div>
                                    </td> -->
                                    <td class="td_markup">{{ change.item.howz_initiatief }}</td>
                                    <td class=" td_markup booking-color row-pointer" v-if="params[0] !== 'huis'">
                                        <table>
                                            <tr>
                                                <td class="td_markup_inner"><span v-on:click="$router.open('/huis/onHuis/' + change.item.huis_encrid)">{{ change.item.accommodation }}</span></td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="td_markup">{{ change.item.assigned_displayname }}</td>
                                    <td class="td_markup">
                                        <v-tooltip top :max-width="400" offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    {{ truncateText(change.item.howz_reden) }}
                                                </span>
                                            </template>
                                            <span>{{ change.item.howz_reden }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="td_markup">
                                        <v-tooltip top :max-width="400" offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    {{ truncateText(change.item.summary) }}
                                                </span>
                                            </template>
                                            <span>{{ change.item.summary }}</span>
                                        </v-tooltip>
                                    </td>
                                    <!-- <td class="td_markup"><longTextView :long_text="change.item.change_info" :max_width="text_max_width"/></td> -->
                                    <td class="td_markup">{{ $moment(change.item.modified).format("DD-MM-YYYY HH:mm") }}</td>
                                    <!-- <td class="td_markup"><longTextView :long_text="change.item.howz_meerkosten" :max_width="text_max_width"/></td> -->
                                    <!-- <td class="td_markup"><longTextView :long_text="change.item.howz_alternatief" :max_width="text_max_width"/></td>                                    -->
                                    <td class="td_markup pb-2">
                                        <table v-for="amount, idx in change.item.compensation" :key=idx style="border-collapse:collapse !important;">
                                            <tr :class="{'border-xs': !(idx+1===(change.item.compensation.length)) }">                                                
                                                <td :class="{'td-markup-xs': true, 'td-code': true, 'border-xs': !(idx+1===(change.item.compensation.length)) }">{{ amount.type }}</td>                                            
                                                <td :class="{'td-markup-xs': true, 'td-name': true, 'booking-color': true, 'row-pointer': true, 'border-xs': !(idx+1===(change.item.compensation.length)) }">
                                                    <span v-if="amount.type==='Guest'" v-on:click="$router.open('/klnt/onKlnt/' + amount.encrid)">
                                                        {{ amount.name | max_char(25) }}
                                                    </span>
                                                    <span v-else v-on:click="$router.open('/eign/onEign/' + amount.encrid)">
                                                        {{ amount.name | max_char(25) }}
                                                    </span>
                                                </td>                                            
                                                <td :class="{'td-markup-xs': true, 'td-amount': true, 'border-xs': !(idx+1===(change.item.compensation.length)) }">{{ amount.amount | nl_numberformat}}</td>
                                            </tr>
                                        </table>
                                    </td>                                    
                                    <td class="td_markup">{{ change.item.howz_hwst_display }}</td>
                                    <td class="td_markup">
                                        <div v-if="!!change.item.attachments">
                                            {{ change.item.attachments }}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <div v-if="this.params[0] == 'all'">
            <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
        </div>
        <div v-else>
            <navBar title="Ares - Overview" :home="true" goto="/task/customer_success/mnCustomerSuccess"/>
        </div>
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import select_gebr from '@/components/ui/selectors/select_gebr.vue'
    import date_picker from '@/components/ui/date_picker.vue';
    import filter_eventstatus from '@/components/huov/howz/ui/filter_eventstatus.vue'

    import mxnumberformat from '@/mixins/amount_nl';
    import mxmaxchar from '@/mixins/filtermaxchar';

    export default {
        props: ['param'],
        components: {
            navBar,
            select_gebr,
            filter_eventstatus,
            date_picker,
        },
        mixins:[mxnumberformat, mxmaxchar],  
        data() {
            return {
                search: '',
                text_max_width: 150,     // For all long texts
                changes: [],
                loading: false,
                params: [],
                selected_gebr: null,
                selected_hwst: [],
                filterstate: '',
                bar_height: 0,
                card_height: 0,
                arrivalDateFromISO: null, 
                arrivalDateUntilISO: null,
                wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
                title: 'Changes overview',
            }
        },    
        created() { // set up event bus listener here on created event or get data
            window.addEventListener("resize", this.resizeEventHandler);

            if (this.param != null) {
                this.params = this.param.split(":");
            }
            this.getOverview();
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeEventHandler);
        },
        mounted() {
        },
        computed: {  // Dit is traaaaaaag....
            filteredChanges: function(){            
                return this.changes.filter((change) => {                
                    // status
                    if(this.selected_hwst !== null && this.selected_hwst.length !== 0) {
                        let matches_status = false;
                        for(let idx=0; idx < this.selected_hwst.length; idx++) {                         
                            if(change.howz_hwst === this.selected_hwst[idx]) {
                                matches_status = true;
                                break;
                            }
                        }
                        if (!matches_status) {
                            return false;
                        }
                    }

                    // user
                    if(this.selected_gebr !== null) {
                        if (change.assigned !== this.selected_gebr) {
                            return false;
                        }
                    }   
                    
                    // dates
                    if(this.arrivalDateFromISO !== null) {
                        if (change.arrival < this.arrivalDateFromISO) {
                            return false;
                        }
                    }
                    if(this.arrivalDateUntilISO !== null) {
                        if (change.arrival > this.arrivalDateUntilISO) {
                            return false;
                        }
                    }          
                    
                    return true;
                });
            },             
        }, 
        methods: {     
            truncateText(text) {
                if (!text) return '';
                return text.length > 80 ? text.slice(0, 80) + '…' : text;
            },
            updateData(data){
                //console.log(data);
                this[data.field] = data.value;
            },
            resizeEventHandler() {
                this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
            },
            getOverview() {
                this.loading = true;
                this.$axios
                    .post("ares/json/ares/task/customer_success/howz/getHowzOverviewV3.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHowzOverview"
                        },
                        getHowzOverview: {
                            params: this.params,
                        }
                    })
                    .then(res => {
                        if (res.data.header.result == "error") {
                            console.log(res.data.error);
                        } else {
                            this.changes = res.data.getHowzOverview;
                            this.filterstate = res.data.header.state;
                            this.title += (' ' + res.data.header.entityvalue);
                            this.$refs.cbo_eventstatus.fixDropDown(res.data.header.state === 'open')
                        }
                        this.loading = false;
                    })
            },             
            getHowzHeaders() {
                switch (this.params[0]) {                
                    case 'all':
                    case 'klnt':     
                    case 'user': 
                    case 'eign': 
                        return [
                            { text: "Booking Arrival", value: "booking", sortable: true, width: '5%' },
                            { text: "Ctr", value: "cttp_nr", width: "4%", sortable: true },
                            { text: "Guest", value: "guest", sortable: true, width: '5%' },
                            { text: "Filed", value: "created", sortable: true, width: '5%' },
                            { text: "Initiator", value: "howz_initiatief", sortable: true, width: '5%' },
                            { text: "Accom.", value: "accommodation", sortable: true, width: '5%' },
                            { text: "Assigned", value: "assigned", sortable: true, width: '5%' },
                            { text: "Reason", value: "howz_reden", sortable: false, width: '10%'},
                            { text: "Latest development", value: "summary", sortable: false, width: '10%'},
                            // { text: "Change information", value: "change_info", sortable: false, width: '10%'},
                            { text: "Updated", value: "modified", sortable: true, width: '5%' },
                            // { text: "Additional costs", value: "howz_meerkosten", sortable: false, width: '10%'},
                            // { text: "alternatives", value: "howz_alternatief", sortable: false, width: '10%'},
                            { text: "Compensation", value: "", sortable: false, width: '15%' },
                            { text: "Stat", value: "howz_hwst_display", sortable: true, width: '10%' },
                            { sortable: false, value: "attachments", align: "center", width: '1%'},
                        ];
                    case 'huis':
                        return [
                            { text: "Booking/Arrival", value: "booking", sortable: true, width: '5%' },
                            { text: "Ctr", value: "cttp_nr", width: "4%", sortable: true },
                            { text: "Guest", value: "guest", sortable: true, width: '5%' },
                            { text: "Filed", value: "created_dmy", sortable: true, width: '5%'},
                            { text: "Initiator", value: "howz_initiatief", sortable: true, width: '5%' },
                            { text: "Assigned", value: "assigned", sortable: true, width: '5%' },
                            { text: "Reason", value: "howz_reden", sortable: false, width: '10%'},
                            { text: "Latest development", value: "summary", sortable: false, width: '10%'},
                            // { text: "Change information", value: "change_info", sortable: false, width: '10%'},
                            { text: "Updated", value: "modified", sortable: true, width: '5%' },
                            // { text: "Additional costs", value: "howz_meerkosten", sortable: false, width: '10%'},
                            // { text: "alternatives", value: "howz_alternatief", sortable: false, width: '10%'},
                            { text: "Compensation", value: "", sortable: false, width: '15%' },
                            { text: "Status", value: "howz_hwst_display", sortable: true, width: '10%' },
                            { sortable: false, value: "attachments", align: "center", width: '1%'},
                        ];

                }
            },
            exportDataToExcel(){

                let e_changes=[];

                let aGuest = 0;
                let aOwner = 0;
                let aCaretaker = 0;
                let aLeniency = 0;

                for(let t = 0; t < this.filteredChanges.length; t++){
                    
                    let el = new Object();

                    el["Booking"]=this.filteredChanges[t].booking;
                    el["Guest"]=this.filteredChanges[t].guest;
                    el["Arrival"]=new Date(this.filteredChanges[t].arrival);
                    el["Filed"]=new Date(this.filteredChanges[t].created);
                    el["Partner"]=this.filteredChanges[t].partner;
                    el["Accommodation"]=this.filteredChanges[t].accommodation;
                    el["Owner"]=this.filteredChanges[t].owner_displayname;
                    el["Acco Country"]=this.filteredChanges[t].acco_country;
                    el["Guest Country"]=this.filteredChanges[t].guest_country;
                    el["Assigned to"]=this.filteredChanges[t].assigned_displayname;
                    el["Initator"]=this.filteredChanges[t].howz_initiatief;
                    el["Change type"]=this.filteredChanges[t].change_type;
                    el["Change info"]=this.filteredChanges[t].change_info;
                    el["Latest Development"]=this.filteredChanges[t].summary;
                    el["Modified"]=new Date(this.filteredChanges[t].modified); // formatted so it can be sorted as a date in Excel
                    el["Status"]=this.filteredChanges[t].howz_hwst_display;
                    el["Closed"] = +this.filteredChanges[t].num_closed_events;


                    el["Comp. guest"]=0;
                    el["Comp. by owner (+ct)"]=0;
                    el["Comp. by caretaker"]=0;
                    el["Leniency VfY"]=0;
                    this.filteredChanges[t].compensation.forEach(obj => {
                        switch(obj.role){
                            case 0:                             
                                el["Comp. guest"] = obj.amount === '0' ? 0 : +obj.amount;     
                                break;
                            case 10:
                            case 12: 
                                el["Comp. by owner (+ct)"] = obj.amount === '0' ? 0 : +obj.amount;
                                break;
                            case 20:  
                                el["Comp. by caretaker"] = obj.amount === '0' ? 0 : +obj.amount;     
                                break;       
                        }
                    });
                    el["Leniency VfY"] = el["Comp. guest"] + el["Comp. by owner (+ct)"] +  el["Comp. by caretaker"];

                    el["Handling time"]=this.filteredChanges[t].handling_time;
                    e_changes.push(el);

                    // attachments += el["Attachments"];
                    aGuest += +el["Comp. guest"];
                    aOwner += +el["Comp. by owner (+ct)"];
                    aCaretaker += +el["Comp. by caretaker"];
                    aLeniency += +el["Leniency VfY"];
                }

                var XLSX = require("xlsx");
                var ws = XLSX.utils.json_to_sheet(e_changes);
                var wb = XLSX.utils.book_new();
                
                // totals
                var cell = "Q" + (e_changes.length + 3); // 1 = empty line, 1 = columnheaders, 1 is actual line we need to be (=3)
                // the prepended + sign makes sure that Excel understands it's a number. Passing it this way enables you to calculate with the values in Excel.
                XLSX.utils.sheet_add_aoa(ws,[["Totals", aGuest, aOwner, aCaretaker, aLeniency]], {origin: cell}); // we write starting from cell K + number value of cell

                XLSX.utils.book_append_sheet(wb, ws, "Changes");
                XLSX.writeFile(wb, 'Changes.xlsx');
            }
        }
    }
</script>

<style scoped> 
    .row-pointer {
        cursor: pointer;
    }

    .row-default {
        cursor: default;
    }

    .booking-color {
        color: blue;
    }
    .no-booking-color {
        color: black;
    }    
    .subtitle-weight{
        font-weight: 400;
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td_markup_inner {
        vertical-align: top;
        /* border-top: 5px solid transparent; */
        border-top: 0px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td-code{
        width: 7.5em;
    }
    .td-name{
        width: 8em;
    }    
    .td-amount{
        width: 5em;
        text-align: end !important;
    }    
    .td-markup-xs {
        padding-top: 1px;
        padding-bottom: 2px;
        vertical-align: top;        
    }
    .border-xs{
        border-bottom: 1px solid lightgrey;
    }
</style>
    .truncate-2-lines {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal !important;
        max-width: 100%;
    }